import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Util} from "../../controller/Util";

@Component({
    selector: 'app-date-navigator',
    templateUrl: './date-navigator.component.html',
    styleUrls: ['./date-navigator.component.css'],
    standalone: false
})
export class DateNavigatorComponent implements OnInit, AfterViewInit {

    @Output() alterouData = new EventEmitter()
    
    @Input() dataInit = Util.getDateComUmMesAntes();
    @Input() dataFim = Util.getLastDayDate();

    dataLabel = ''
    anosOptions = [
        // {label: '2015', value: 2015},
        // {label: '2016', value: 2016},
        {label: '2017', value: 2017},
        {label: '2018', value: 2018},
        {label: '2019', value: 2019},
        {label: '2020', value: 2020},
        {label: '2021', value: 2021},
        {label: '2022', value: 2022},
        {label: '2023', value: 2023},
        {label: '2024', value: 2024},
        {label: '2025', value: 2025},
        {label: '2026', value: 2026},
        {label: '2027', value: 2027},
        {label: '2028', value: 2028},
        {label: '2029', value: 2029},
        {label: '2030', value: 2030},
        {label: '2031', value: 2031},
        {label: '2032', value: 2032},
        {label: '2033', value: 2033},
    ];
    exibirOpcoesMes = false;

    constructor() {
    }

    ngOnInit(): void {

    }

    get yearValueToDropdown() {
        return this.dataInit.getFullYear()
    }

    defineLabelData() {
        const monthLabel = ['Janeiro', 'Fevereiro', 'Marco', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
        this.dataLabel = `${monthLabel[this.dataInit.getMonth()]} - ${this.dataInit.getFullYear()}`
    }

    nextDate() {
        this.dataInit = new Date(this.dataInit.getFullYear(), this.dataInit.getMonth() + 1, 1)
        this.dataFim = new Date(this.dataInit.getFullYear(), this.dataInit.getMonth() + 1, 0)        
        this.defineLabelData()
        this.notificarAlteracaoData()
    }

    backDate() {
        this.dataInit = new Date(this.dataInit.getFullYear(), this.dataInit.getMonth() - 1, 1)
        this.dataFim = new Date(this.dataInit.getFullYear(), this.dataInit.getMonth() + 1, 0)        
        this.defineLabelData()
        this.notificarAlteracaoData()
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            this.defineLabelData()
        }, 50)
    }

    notificarAlteracaoData() {
        this.alterouData.emit({
            dataInicial: this.dataInit,
            dataFinal: this.dataFim,
        });
    }

    setMonth(mes: number) {
        this.dataInit = new Date(this.dataInit.getFullYear(), mes, 1)
        this.dataFim = new Date(this.dataInit.getFullYear(), mes + 1, 0)
        this.defineLabelData()
        this.notificarAlteracaoData()
        this.exibirOpcoesMes = false;
    }

    clickOutside() {
        if(this.exibirOpcoesMes) this.exibirOpcoesMes = false;
    }

    openCloseOpcoes(event: any) {
        this.exibirOpcoesMes = !this.exibirOpcoesMes
        event.stopPropagation()
    }

    setYear(e: any) {
        this.dataInit = new Date(e.value, this.dataInit.getMonth(), 1)
        this.dataFim = new Date(e.value, this.dataInit.getMonth() + 1, 0)
        this.defineLabelData()
        this.notificarAlteracaoData()
    }
}